import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=5e0d91b3&scoped=true&lang=less"

import exportComponent from "C:\\Users\\PC\\AppData\\Local\\Temp\\tecs-enduser-release-cd96384e-20260902-1753\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0d91b3"]])

export default __exports__